import { Grid, Box, Stack, Skeleton } from '@mui/material';

export const GainsLossLoadingSkeletons = ({ repeat = 1 }) => {
  return (
    <Grid
      container
      spacing={{ xs: 4, md: 8 }}
    >
      {Array.from({ length: repeat }, (_, index) => (
        <Grid
          size={{ xs: 10, sm: 6, md: 4 }}
          key={index}
        >
          <Box>
            <Stack
              direction='column'
              flex={1}
              gap={2}
            >
              <Skeleton width={'50%'} />
              <Skeleton />
              <Skeleton />
            </Stack>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
